import React, { Component } from "react";
import { MdClose } from "react-icons/md";
import InfiniteScroll from "react-infinite-scroll-component";
import { Link } from "react-router-dom";
import Empty from "../../../base/features/blocks/Empty";
import ProductCard from "../../../base/features/blocks/ProductCard";
import Spinner from "../../../base/features/micro/Spinner";
import { getMoreShopProducts, shopProducts } from "../services";
import ProductsFilterBlock from "./blocks/ProductsFilterBlock";
import ShopCategoryItem from "../blocks/shopCategoryItem";
import Image from "../../../base/features/micro/Image";
import OpenApp from "react-open-app";
import createLink from "../../../base/utils/createLink";
import DynamicView from "../../dynamicView/DynamicView";
import { getShopUid, isSiteDomain } from "../../../settings/domainManager";
import { navigate_to_shop_personalized_product_from_url } from "../../../navigator/user/product";

class Products extends Component {
  constructor(props) {
    super(props);
    this.state = {
      products: null,
      hasMore: false,
      nextUrl: "",
      searchKey: "",
      shop_uid: getShopUid(),
      rowsCount: 1,
      selectedCategory: "",
      selectedCategoryView: null,
      shopProperties: null,
    };
  }

  componentDidMount() {
    let productsItemCount = localStorage.getItem("productsItemCount");
    if (productsItemCount) {
      this.setState({ rowsCount: Number(productsItemCount) });
    }

    this.getShopProducts();
  }

  fetchMoreData() {
    getMoreShopProducts(this.state.nextUrl).then((items) => {
      if (items) {
        let newProducts = this.state.products;
        newProducts = newProducts.concat(items.results);

        this.setState({
          products: newProducts,
          nextUrl: items.next,
          hasMore: !!items.next,
        });
      }
    });
  }

  getShopProducts() {
    let q = this.state.searchKey;
    let shop_category = this.state.selectedCategory || "";
    shopProducts(this.state.shop_uid, q, shop_category).then((items) => {
      if (q === this.state.searchKey && items) {
        this.setState({
          products: items.results,
          hasMore: !!items.next,
          nextUrl: items.next,
        });
      }
    });
  }

  get verifyText() {
    if (
      this.props.shopProperties.personalize &&
      this.props.shopProperties.personalize.verify_text
    )
      return this.props.shopProperties.personalize.verify_text;
    return "احراز هویت شده توسط گیتی مارکت";
  }

  get showVerify() {
    return this.props.shopProperties.is_verify && !isSiteDomain;
  }

  get showSubTitle() {
    return !isSiteDomain;
  }

  render() {
    return (
      <div className="container-fluid px-0">
        <div
          className="row mx-0 px-0"
          style={{ marginBottom: "80px", marginTop: "60px" }}
        >
          <div className="text-center mt-1">
            <Image
              imageUri={
                this.props.shopProperties &&
                this.props.shopProperties.cover &&
                this.props.shopProperties.cover.file
              }
              imgClassName={"img-cover rounded14"}
              imageHeight={"80"}
              imageWidth={"80"}
              extraClassName={"rounded-circle bg-color-main p-2"}
            />
          </div>
          <div className="row mx-0 my-2 px-4 mb-4 text-center">
            <div className="col px-0 pe-2">
              <h1 className="fs-3 fw-bolder mb-0">
                {this.props.shopProperties.title}
              </h1>
              {this.showSubTitle && (
                <p className="fs-6 text-muted fw-bold mb-1">
                  {this.props.shopProperties.sub_title}
                </p>
              )}
              {/*{this.props.shopProperties.categories.length > 0 &&*/}
              {/*this.props.shopProperties.categories.map(*/}
              {/*    (category, c) => (*/}
              {/*        <Link*/}
              {/*            to={`/search?categoryUid=${category.uid}&categoryTitle=${category.title}`}*/}
              {/*        >*/}
              {/*<span*/}
              {/*    className="ps-2 d-inline-block fs-7 color-main"*/}
              {/*    key={c}*/}
              {/*>*/}
              {/*  {category.title}*/}
              {/*</span>*/}
              {/*        </Link>*/}
              {/*    )*/}
              {/*)}*/}
            </div>
          </div>

          {this.showVerify && (
            <div className="row mx-0 px-4 mb-4">
              <div className="row mx-0 rounded14 bg-light-green px-4 py-3">
                <div className="col-auto align-self-center px-0">
                  <img
                    alt="verify"
                    src={
                      require("../../../base/assets/icons/verify.svg").default
                    }
                  />
                </div>
                <div className="col px-2 align-self-center">
                  <p className="color-main mb-0 fw-bold fs-6">
                    {this.verifyText}
                  </p>
                </div>
                {/* <div className="col-auto align-self-center px-0 color-main">
                        <FiChevronLeft size="22" />
                      </div> */}
              </div>
            </div>
          )}

          {this.props.shopProperties.quick_contacts &&
          this.props.shopProperties.quick_contacts.length > 0 ? (
            <div className="row mx-0 px-4 py-1">
              {this.props.shopProperties.quick_contacts.map((contact, c) => (
                <div className="col px-1">
                  <OpenApp
                    href={createLink(contact)}
                    android={createLink(contact, "android")}
                    ios={createLink(contact)}
                  >
                    <button className="btn w-100 py-2 fw-bold small border color-main rounded28">
                      <Image
                        imageUri={
                          contact.type.icon && contact.type.icon.icon_128
                        }
                        imgClassName={"img-cover ms-2"}
                        imageHeight={"20"}
                        imageWidth={"20"}
                        extraClassName={"rounded-circle bg-color-main p-1"}
                      />
                      {contact.type.title}
                    </button>
                  </OpenApp>
                </div>
              ))}
            </div>
          ) : (
            ""
          )}

          {this.props.shopProperties.views &&
            this.props.shopProperties.views.products_under_shop_info && (
              <DynamicView
                viewPage="shopHome"
                view={this.props.shopProperties.views.products_under_shop_info}
              />
            )}

          {this.props.product_categories &&
            this.props.product_categories.length > 0 && (
              <div
                style={{
                  overflow: "scroll hidden",
                  whiteSpace: "nowrap",
                }}
                className="px-0 mx-1 py-3 col-12 scrollbar-hide"
              >
                <ShopCategoryItem
                  key={"all"}
                  category={null}
                  text={"همه"}
                  selected={this.state.selectedCategory === ""}
                  onClick={(selected) => {
                    this.setState({ selectedCategory: "" }, () => {
                      if (selected) {
                        this.getShopProducts();
                      }
                    });
                  }}
                ></ShopCategoryItem>

                {this.props.product_categories.map((item, index) => (
                  <ShopCategoryItem
                    key={index}
                    category={item}
                    text={item.name}
                    selected={this.state.selectedCategory === item.uid}
                    onClick={(selected) => {
                      this.setState({ selectedCategory: item.uid }, () => {
                        if (selected) {
                          this.getShopProducts();
                        }
                      });
                    }}
                  ></ShopCategoryItem>
                ))}
              </div>
            )}
          <div
            className="col-12 px-4 py-3 text-center position-sticky bg-white"
            style={{ top: "59px", zIndex: "99999" }}
          >
            <input
              type="text"
              value={this.state.searchKey}
              onChange={(e) =>
                this.setState({ searchKey: e.target.value }, () => {
                  this.getShopProducts();
                })
              }
              className="form-control px-3 py-2 rounded14 w-100"
              style={{ height: "44px" }}
              placeholder="جستجو کنید"
            />
            {this.state.searchKey.length !== 0 && (
              <MdClose
                size={26}
                style={{ left: "37px", top: "0", bottom: "0" }}
                className="position-absolute my-auto"
                onClick={() =>
                  this.setState({ searchKey: "" }, () => {
                    this.getShopProducts();
                  })
                }
              />
            )}
          </div>
          {this.props.config && this.props.config.personalized_product && (
            <div className="col-12 px-4 pb-3 text-center">
              <Link to={navigate_to_shop_personalized_product_from_url()}>
                <button className="btn p-0 w-100">
                  <img
                    alt="personalized_product"
                    className="w-100"
                    src={
                      require("../../../base/assets/images/personalized_product.png")
                        .default
                    }
                  />
                </button>
              </Link>
            </div>
          )}
          <ProductsFilterBlock
            rowsCount={this.state.rowsCount}
            changeRows={(count) => this.setState({ rowsCount: count })}
          />

          {this.state.products ? (
            <InfiniteScroll
              dataLength={this.state.products.length}
              next={() => this.fetchMoreData()}
              hasMore={this.state.hasMore}
              className="row"
              loader={<Spinner />}
            >
              {this.state.products.length === 0 && (
                <Empty type="product" text={"محصول مورد نظر پیدا نشد."} />
              )}
              {this.state.products.map((product, p) => (
                <div
                  key={p}
                  className={`${
                    this.state.rowsCount === 1
                      ? "col-12"
                      : `col-6 ${p % 2 === 0 ? "border-start" : ""}`
                  } px-0 border-bottom`}
                >
                  <ProductCard
                    product={product}
                    shopUid={this.state.shop_uid}
                    rowsCount={this.state.rowsCount}
                    onlineOrdering={
                      this?.props?.shopProperties?.services || false
                    }
                  />
                </div>
              ))}
            </InfiniteScroll>
          ) : (
            <div style={{ marginTop: "20px", zIndex: "-2" }}>
              <Spinner />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default Products;
